//
//
//
//
//
//
//



export default {
    name: 'auth-layout',
    computed: {

    },
    watch:{

    }
}
